import React from 'react';
import styled from 'styled-components';

/**
 * 招待リンクのエラー系フルページ画面の共通レイアウト。
 * アイコン・タイトル・説明のみ差し替えて使う（登録済み / 期限切れ 等）。
 * デザイントークンは共有の EmptyState に準拠。
 */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 100vh;
  padding: ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.md};
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.pageBackground};
`;

const IconWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Title = styled.h1`
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Description = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.5;
  white-space: pre-line;
`;

export interface LinkTokenErrorScreenProps {
  /** 中央に表示するアイコン */
  icon: React.ReactNode;
  /** 見出し */
  title: string;
  /** 説明文（\n で改行可） */
  description: string;
}

export const LinkTokenErrorScreen: React.FC<LinkTokenErrorScreenProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <Container>
      <IconWrapper>{icon}</IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};

export default LinkTokenErrorScreen;
